import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/vipImg/icon__vip_logo@2x.png'
import _imports_1 from '@/assets/image/vipImg/icon_tab_vip@2x.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "vip-logo"
}, null, -1)
const _hoisted_2 = { class: "membership-center" }
const _hoisted_3 = { class: "wrap" }
const _hoisted_4 = { class: "tag" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "member-status" }
const _hoisted_8 = { class: "tips" }
const _hoisted_9 = { class: "explain mt_15" }
const _hoisted_10 = { style: {"padding":"0 !important"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_12 = { class: "text" }

import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRtfix, useSite2Station, isJA, isKO, useSite } from '@/store'
import { t } from '@/plugins/i18n'
import { Site } from '@/common/const'
import { getActivePriceByStation, getCurrentMonetaryUnit } from '@/util/useYan'
import { TaEvent, taTrack } from '@/util/buryingPoint'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const vipClick = () => {
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: 'member'
    }
  })
  if (!store.getters.isLogin) {
    taTrack({
      event: TaEvent.PUPUP_WINDOW,
      value: {
        source: 'member',
        position: 'login'
      }
    })
  }
}
const effectList = ref([ // 功能列表
  {
    id: 1,
    text: t('能够在中国找到丰富的供应商')
  },
  {
    id: 2,
    text: t('按照日本质量标准进行检验（隶属于日本公司）')
  },
  {
    id: 3,
    text: t('最低国际运费保证，可运往23个国家/地区')
  },
  {
    id: 4,
    text: t('可靠的支持和即时的客户服务')
  }
])
const newMemberActivity = computed(() => store.state.status.newMemberActivity.id ? store.state.status.newMemberActivity : false)

const currentMonetaryUnit = getCurrentMonetaryUnit()

const getActivityVipImage = () => {
  if (isJA()) {
    return 'https://static-s.theckb.com/BusinessMarket/member/active_member_pop.png'
  } else if (isKO()) {
    return 'https://static-s.theckb.com/BusinessMarket/member/vip_pop_ko1.png'
  } else {
    return 'https://static-s.theckb.com/BusinessMarket/member/tabbar_pop_up_background_en.png'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createBlock(_component_el_popover, {
    ref: (_value, _refs) => {
      _refs['popoverRef'] = _value
    },
    trigger: "hover",
    width: "300px",
    "popper-class": 'memberExpire-popver memberExpire-popver-' + _unref(useSite)()
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", {
        class: "ml_30 point",
        onClick: vipClick
      }, [
        _createVNode(_component_router_link, {
          to: _unref(useRtfix)('VipLevel'),
          class: "light"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('会员中心')), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('我的会员')), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(t)('未登录')), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)('入会优享超多服务')), 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(effectList.value, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.id,
                  class: "list flex ter"
                }, [
                  _hoisted_11,
                  _createElementVNode("p", _hoisted_12, _toDisplayString(item.text), 1)
                ]))
              }), 128))
            ])
          ]),
          _createVNode(_component_router_link, { to: "/login" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, { class: "btn" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('去登录')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["popper-class"]))
}
}

})